"use strict";

var _regeneratorRuntime = require("/opt/build/repo/app/node_modules/@babel/runtime/regenerator/index.js");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateProviderProps = void 0; // @ts-expect-error missing types

var server_1 = __importDefault(require("@appbaseio/reactivesearch/lib/server"));

var config_1 = require("./config");

var props_1 = require("./props");

var generateProviderProps = function generateProviderProps(options) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var config, props;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, config_1.getConfig)(options.shopifyPermanentDomain);

          case 2:
            config = _context.sent;
            props = (0, props_1.getPropsFilterGroup)({
              mode: options.mode,
              config: config,
              filterGroup: config.filters[0]
            });
            _context.t0 = Object;
            _context.t1 = Object.assign({}, options);
            _context.t2 = config;
            _context.next = 9;
            return (0, server_1.default)(props, null, {
              app: config.index,
              url: config.endpoint
            });

          case 9:
            _context.t3 = _context.sent;
            _context.t4 = {
              config: _context.t2,
              state: _context.t3
            };
            _context.t5 = {
              preload: _context.t4
            };
            return _context.abrupt("return", _context.t0.assign.call(_context.t0, _context.t1, _context.t5));

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

exports.generateProviderProps = generateProviderProps;